const NAME = "FEEDBACK";

export default NAME;
